exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bug-svg[data-v-4eba243a] {\n\twidth: 1em;\n\theight: 1em;\n\tvertical-align: -0.15em;\n\tfill: currentColor;\n\toverflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4eba243a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ErrLog/index.vue
// module id = 256
// module chunks = 88